import clsx from 'clsx';
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Link, Typography } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: { padding: theme.spacing(4) }
}));

const Footer = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  return (
    <div
      {...rest}
      className={clsx(
        classes.root,
        className
      )}
    >
      <Typography
        color="textSecondary"
        variant="body2"
      >
        &copy;{' '}
        <Link
          component="a"
          href="http://sisare.com.br"
          target="_blank"
        >
          A2X Sistemas
        </Link>
        . {new Date().getFullYear().toString()}
      </Typography>
    </div>
  );
};

Footer.propTypes = {
  className: PropTypes.string
};

export default Footer;